import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SettingsScreen.css';

const SettingsScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="settings-screen">
      <div className="settings-topbar">
        <button
          className="settings-back-btn"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          ‹
        </button>

        <h2 className="settings-title">Settings</h2>

        <div className="settings-topbar-spacer" />
      </div>

      <div className="settings-content">
        <button
          className="settings-option-card"
          onClick={() => navigate('/settings/blocked-accounts')}
        >
          <div className="settings-option-left">
            <div className="settings-option-icon">🚫</div>

            <div>
              <div className="settings-option-title">Blocked Accounts</div>
              <div className="settings-option-subtitle">
                View and manage users you have blocked
              </div>
            </div>
          </div>

          <span className="settings-option-arrow">›</span>
        </button>
      </div>
    </div>
  );
};

export default SettingsScreen;
